(function() {
    'use strict';

    var utils = require('./utils');

    // Cleave
    var Cleave = require('cleave.js');
    var Inputmask = require('inputmask');
    var im = new Inputmask("A9A 9A9");
    // require('cleave.js/dist/addons/cleave-phone.ca');
    var cleaveInstances = [];

    // NAS
    var cleaveNas = document.querySelectorAll('[cleave="nas"]');
    if (cleaveNas.length) {
        utils.forEach(cleaveNas, function (index, element) {
            new Cleave(element, {
                //numericOnly: true,
                blocks: [3, 3, 3],
                delimiter: ' '
            });
        });
    }

    // postal code
    var cleavePostalCodes = document.querySelectorAll('[cleave="postal-code"]');
    if (cleavePostalCodes.length) {
        utils.forEach(cleavePostalCodes, function (index, element) {
            im.mask(element);
        });
    }

    // phone
    var cleavePhones = document.querySelectorAll('[cleave="phone"]');
    if (cleavePhones.length) {
        utils.forEach(cleavePhones, function (index, element) {
            var newPhoneCleave = new Cleave(element, {
                // phone: true,
                // phoneRegionCode: 'ca',
                numericOnly: true,
                blocks: [3, 3, 4],
                delimiter: '-'
            });
            cleaveInstances.push(newPhoneCleave);
        });
    }

    // date
    var cleaveDates = document.querySelectorAll('[cleave="date"]');
    if (cleaveDates.length) {
        utils.forEach(cleaveDates, function (index, element) {
            new Cleave(element, {
                numericOnly: true,
                blocks: [4, 2, 2],
                delimiter: '/'
            });
        });
    }

    // money
    var cleaveMoney = document.querySelectorAll('[cleave="money"]');
    if (cleaveMoney.length) {
        utils.forEach(cleaveMoney, function (index, element) {
            var max = element.getAttribute('max');

            new Cleave(element, {
                numeral: true,
                delimiter: ' ',
                numeralThousandsGroupStyle: 'thousand',
                onValueChanged: function(e) {
                    if (max) {
                        var rawValue = e.target.rawValue;
                        if (rawValue > parseInt(max)) {
                            this.setRawValue(max);
                        }
                    }
                }
            });
        });
    }

    var cleaveRemove = document.querySelectorAll('[cleave-remove]');
    if (cleaveRemove.length > 0) {
        utils.forEach(cleaveRemove, function (index, element) {
            checkCleaveAttr(element);
            element.addEventListener('click', function () {
                checkCleaveAttr(this);
            });
        });
    }

    function checkCleaveAttr(element)
    {
        var ids = element.getAttribute('cleave-remove').split(' ');
        ids.forEach(function (id) {
            var input = document.querySelector(id);
            var selectedCleave = cleaveInstances.find(function(instance) {
                return instance.element === input;
            });

            if (element.checked) {
                switch (input.getAttribute('cleave-object')) {
                    case 'postal-code': {
                        if (input.inputmask) {
                            input.inputmask.remove();
                        }
                        break;
                    }
                    case 'phone': {
                        if (selectedCleave) {
                            var index = cleaveInstances.indexOf(selectedCleave);
                            var savedRawValue = selectedCleave.getRawValue();

                            selectedCleave.destroy();
                            selectedCleave.element.value = savedRawValue;
                            cleaveInstances.shift(index, 1);
                        }
                        break;
                    }
                }
            } else {
                switch (input.getAttribute('cleave-object')) {
                    case 'postal-code': {
                        im.mask(input);
                        break;
                    }
                    case 'phone': {
                        if (!selectedCleave) {
                            var newCleave = new Cleave(input, {
                                // phone: true,
                                // phoneRegionCode: 'ca',
                                numericOnly: true,
                                blocks: [3, 3, 4],
                                delimiter: '-'
                            });
                            cleaveInstances.push(newCleave);
                        }
                        break;
                    }
                }
            }
        });
    }

})();
